import { useAuth } from '@viabl/echo-web-client-core';
import * as React from 'react';
import { Navigate, useLocation } from 'react-router';

export function RequireAuth({children}: {children: React.JSX.Element}) {
    let auth = useAuth();
    let location = useLocation();

    console.log("User", auth.user);

    if (auth?.user?.user_id === undefined) {
        return <Navigate to={"/signin?returnUrl=" + encodeURIComponent(location.pathname + location.search)}/>;
    }

    return children;
}

// export function RequireAuthRingmaster({children}: {children: JSX.Element}) {
//     let auth = useAuth();

//     if (auth?.user?.engineer_id === undefined || auth.user?.contractor_type !== AllocationStyle.Ringmaster) {
//         return <Navigate to="/" replace />
//     }

//     return children;
// }